export function dayCheckinStatusColor(status) {
  if (status === 'on_time' || status === 'marked') return 'success';
  if (status === 'late' || status === 'not_marked') return 'error';
  if (status === 'on_leave') return 'info';
  if (status === 'not_yet') return 'warning';
  return 'default';
}

export const DAY_CHECKIN_STATUS_FILTERS = [
  { id: 'all', label: 'All' },
  { id: 'on_time', label: 'On time' },
  { id: 'late', label: 'Late' },
  { id: 'not_yet', label: 'Not yet' },
  { id: 'not_marked', label: 'Not marked' },
  { id: 'on_leave', label: 'On leave' },
  { id: 'marked', label: 'Marked' },
];
